var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getCookie } from '.';
/**
 * Operations we want to apply for all analytics events should be added as middleware
 * to allow a standard `window.analytics.track` call to handle custom logic such as adding
 * additional ids, enhancing events with special properties, filtering out sensitive data, etc
 * */
function withTiktokPixelCookies(_a) {
    var payload = _a.payload, next = _a.next;
    var type = payload.type();
    var ttpCookie = getCookie('_ttp');
    var ttclidCookie = getCookie('ttclid');
    if (type === 'track' || type === 'page') {
        payload.obj.properties = __assign(__assign(__assign({}, payload.obj.properties), (ttpCookie && { ttp: ttpCookie })), (ttclidCookie && { ttclid: ttclidCookie }));
    }
    next(payload);
}
function withConciousPartnerCookies(_a) {
    var payload = _a.payload, next = _a.next;
    var type = payload.type();
    var cpclidCookie = getCookie('cpclid');
    if (type === 'track' || type === 'page') {
        payload.obj.properties = __assign(__assign({}, payload.obj.properties), (cpclidCookie && { cpclid: cpclidCookie }));
    }
    next(payload);
}
// Order matters here
var middleware = [
    withTiktokPixelCookies,
    withConciousPartnerCookies,
];
export function applyMiddleware() {
    var _a;
    middleware.forEach((_a = window.analytics) === null || _a === void 0 ? void 0 : _a.addSourceMiddleware);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWlkZGxld2FyZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9taWRkbGV3YXJlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQ0EsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLEdBQUcsQ0FBQztBQUU5Qjs7OztLQUlLO0FBRUwsU0FBUyxzQkFBc0IsQ0FBQyxFQUFpQjtRQUFmLE9BQU8sYUFBQSxFQUFFLElBQUksVUFBQTtJQUM3QyxJQUFNLElBQUksR0FBRyxPQUFPLENBQUMsSUFBSSxFQUFFLENBQUM7SUFDNUIsSUFBTSxTQUFTLEdBQUcsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3BDLElBQU0sWUFBWSxHQUFHLFNBQVMsQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUN6QyxJQUFJLElBQUksS0FBSyxPQUFPLElBQUksSUFBSSxLQUFLLE1BQU0sRUFBRSxDQUFDO1FBQ3hDLE9BQU8sQ0FBQyxHQUFHLENBQUMsVUFBVSxrQ0FDakIsT0FBTyxDQUFDLEdBQUcsQ0FBQyxVQUFVLEdBQ3RCLENBQUMsU0FBUyxJQUFJLEVBQUUsR0FBRyxFQUFFLFNBQVMsRUFBRSxDQUFDLEdBQ2pDLENBQUMsWUFBWSxJQUFJLEVBQUUsTUFBTSxFQUFFLFlBQVksRUFBRSxDQUFDLENBQzlDLENBQUM7SUFDSixDQUFDO0lBQ0QsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0FBQ2hCLENBQUM7QUFDRCxTQUFTLDBCQUEwQixDQUFDLEVBQWlCO1FBQWYsT0FBTyxhQUFBLEVBQUUsSUFBSSxVQUFBO0lBQ2pELElBQU0sSUFBSSxHQUFHLE9BQU8sQ0FBQyxJQUFJLEVBQUUsQ0FBQztJQUM1QixJQUFNLFlBQVksR0FBRyxTQUFTLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDekMsSUFBSSxJQUFJLEtBQUssT0FBTyxJQUFJLElBQUksS0FBSyxNQUFNLEVBQUUsQ0FBQztRQUN4QyxPQUFPLENBQUMsR0FBRyxDQUFDLFVBQVUseUJBQ2pCLE9BQU8sQ0FBQyxHQUFHLENBQUMsVUFBVSxHQUN0QixDQUFDLFlBQVksSUFBSSxFQUFFLE1BQU0sRUFBRSxZQUFZLEVBQUUsQ0FBQyxDQUM5QyxDQUFDO0lBQ0osQ0FBQztJQUNELElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQztBQUNoQixDQUFDO0FBRUQscUJBQXFCO0FBQ3JCLElBQU0sVUFBVSxHQUF5QjtJQUN2QyxzQkFBc0I7SUFDdEIsMEJBQTBCO0NBQzNCLENBQUM7QUFFRixNQUFNLFVBQVUsZUFBZTs7SUFDN0IsVUFBVSxDQUFDLE9BQU8sQ0FBQyxNQUFBLE1BQU0sQ0FBQyxTQUFTLDBDQUFFLG1CQUFtQixDQUFDLENBQUM7QUFDNUQsQ0FBQyJ9